import { render, staticRenderFns } from "./study-review-header.vue?vue&type=template&id=1678383a&scoped=true&"
import script from "./study-review-header.vue?vue&type=script&lang=js&"
export * from "./study-review-header.vue?vue&type=script&lang=js&"
import style0 from "./study-review-header.vue?vue&type=style&index=0&id=1678383a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678383a",
  null
  
)

component.options.__file = "study-review-header.vue"
export default component.exports